// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"ContentRating_pageContainer__10MBJ","title":"ContentRating_title__pf85Q","description":"ContentRating_description__1Wx_9"};